import { AxiosError } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { store } from '../../app/store'
import APIClient from '../../apiClient'
import StatusE from '../../types/statusE'
import { TokenT } from '../../types/tokenT'
import { setError, setIsLoggedIn, setStatus } from './slice'
import { OAuthErrorT } from '../../types/oAuthErrorT'
import { redirectToOAuthAuthorize } from '../../oauth/authorize'
import Token from '../../token'

const apiClient = new APIClient(false)
const apiInstance = apiClient.getInstance()

export default (authorizationCode: string) => (dispatch: typeof store.dispatch) => {
  dispatch(setStatus(StatusE.LOADING))

  if (authorizationCode) {
    const requestData = new URLSearchParams()
    requestData.append('grant_type', 'authorization_code')
    requestData.append('code', authorizationCode)
    requestData.append('client_id', process.env.REACT_APP_OAUTH_CLIENT_ID ?? '')
    apiInstance
      .post<TokenT>(`/oauth/token`, requestData)
      .then((response) => {
        if (!Token.tokenIncludesRequiredScopes(response.data)) {
          Token.clearStoredToken()
          redirectToOAuthAuthorize(uuidv4())
          dispatch(
            setError({
              error: 'insufficient_scope',
              error_description:
                'Your session did not include all required permissions. Signing you in again…',
            })
          )
          return
        }

        Token.persistToken(response.data)
        dispatch(setIsLoggedIn(true))
      })
      .catch((error: AxiosError<OAuthErrorT>) => {
        dispatch(setError(error.response?.data))
      })
  }
}
